import {FORM_ARRAY_BENEVA_GUARANTEED_FUNDS} from '@/constants/engine';
import {ValueResolver} from '@/engine/types';
import {getBenevaAccounts, BenevaAccount} from './get-beneva-accounts';

/**
 * Retrieves Beneva Guaranteed Investment Funds (FP)
 * @param valueResolver - The value resolver function
 * @returns Array of guaranteed investment funds
 */
export const getBenevaGuaranteedInvestmentFunds = (valueResolver: ValueResolver): BenevaAccount[] => {
  return getBenevaAccounts(valueResolver, FORM_ARRAY_BENEVA_GUARANTEED_FUNDS);
};
